<template>
  <div v-if="store.loading">
    <w-progress class="ma1" circle :model-value="undefined" size="6em"></w-progress>
  </div>
  <div v-else>
    <div v-if="!store.currentUser.isLoggedIn">
      <main >
        <router-view />
      </main>
    </div>
    <div v-else>

      <div>
        <w-flex grow>

          <w-drawer v-if="(this.$waveui.breakpoint.sm || this.$waveui.breakpoint.xs)" v-model="openDrawer" left
            class="xs3" width="160px" @click="showMenu = false, openDrawer = false">
            <div class="navbar-wrapper">
              <MainNavbar />
            </div>
          </w-drawer>

          <!-- show menu as burger menu in smaller screen -->
          <w-button v-if="(this.$waveui.breakpoint.sm || this.$waveui.breakpoint.xs)" class="ma1" text lg absolute left
            top @click="showMenu ? showMenu = false : showMenu = true, openDrawer = 'left'">
            <w-icon class="mr1">mdi mdi-menu</w-icon>
          </w-button>

          <!-- show menu as side menu in larger screen -->
          <aside v-else :class="showMenu ? 'xs3 md2' : 'xs1 md1'">
            <w-flex grow>
              <div v-if="showMenu" class="xs11">
                <MainNavbar />
              </div>
              <div class="store.showMenu ? 'xs1' : 'xs12'">
                <w-button text class="ma5 mr6 mt0" bg-color="primary" color="white"
                  :icon="showMenu ? 'mdi mdi-chevron-left' : 'mdi mdi-chevron-right'"
                  @click="showMenu ? showMenu = false : showMenu = true"></w-button>
              </div>
            </w-flex>
          </aside>
          <main :class="showMenu && !openDrawer ? 'xs9 md10 grow ' : 'xs11 md11 grow '">
            <ErrorComponent 
              v-if="errorStore.state.show" :message="errorStore.state.error.message"
              :close="errorStore.state.type=='Alert'"
              :back="errorStore.state.prewRoute"
              :status="errorStore.state.error.statusCode"
              @close="()=>errorStore.clean()"
              ></ErrorComponent>
            <router-view v-if="errorStore.state.type != 'pageError'" />
            <div v-else>
              <w-progress class="ma1" circle :model-value="undefined" size="6em"></w-progress>
            </div>
          </main>
        </w-flex>
      </div>


    </div>
  </div>
</template>

<script>

import { store } from "@/utils/store";
import { errorStore } from "@/modules/errors/store/errors";
import MainNavbar from "@/components/page/MainNavbar";
import ErrorComponent from "@/modules/errors/components/ErrorComponent.vue";


export default {
  name: 'MainPage',
  components: {
    MainNavbar,
    ErrorComponent
  },
  data() {
    return {
      showMenu: (!(this.$waveui.breakpoint.sm || this.$waveui.breakpoint.xs)),
      openDrawer: false,
      store,
      errorStore
    }
  }
}
</script>

<style scoped>
.navbar-wrapper {
  width: 160px;
}

aside {
  text-transform: uppercase;
  background-color: #ffffff;
  /* border-right: 1px solid rgba(0, 0, 0, 0.07); */
}

main {
  color: #666;
  background-color: #ffffff;
}
</style>